import { determineIps, getUser } from "../constants/base/utils";
import {
  getCallSessionById,
  getContactDetails,
  getContactDetailsforAgent,
  getCallNecessaryDetails,
  getNecessaryDetailswithsession,
  updateContactinSession,
} from "../store/api/helperspi/contactListapiService";

import { CallPopUpAgentActions } from "../store/slices/voice_call_slice/call_popup_agent";
import { CallUserAgentActions } from "../store/slices/voice_call_slice/login_user_call_details";
import { ChatActions } from "../store/slices/chat_slice/chat_slice";
import { ChatState } from "../base/models/model";
import { GetItemFromStorage } from "../custom_hooks/useStorage";
import { LocalStorage } from "../custom_hooks/localStorageKeys";
import _ from "lodash";
import callChatService from "../base/service/chatService";
import { CallSDK } from "unifiedring-sdk";
import { config } from "../base/constant";
import { dispositionSliceActions } from "../store/slices/dispositionSlice/postDisposition";
import { notification } from "antd";
import publicIp from "public-ip";
import store from "../store/redux-store/root_store";
import { v4 as uuidv4 } from "uuid";
import { allActivityActions } from "../store/slices/all_activity_slice/all_activity_slice";
import presenceService from "../base/service/presence";
import { ROLES } from "../base/constant";
import { CallServices, SocialmediaServices, WhatsappService } from "../base/service/apiServices";
import { hassAccess, summarySubjectHandlerForCall } from "../base/utils";
import { outboundCampaignSliceAction } from "../store/slices/outboundCampaign/outboundCampaignslice";
import { getPriviousChannelSummary } from "../components/webChatScreen/utils";

let listenInterval: any;
let {
  CallAccept,
  CallHold,
  CallUnHold,
  EndCall,
  MakeCall,
  Mute_AudioCall,
  Registration,
  RejectCall,
  UnMute_AudioCall,
  Unregistration,
  MakeReInviteCall,
  CallConference,
  agentBusy,
  MakeCallOutboundCampiagn
} = CallSDK.Call;
let CallTimer: any;
export function CallService(dispatch: any, navigate: any) {
  let isUAInitializing = false;
  const createCallConnection = async () => {
    if (isUAInitializing) return
    isUAInitializing = true;
    const userDetials = GetItemFromStorage(LocalStorage.USER_DETAILS);
    const wssUrl = GetItemFromStorage(LocalStorage.WSS_URL);
    const LoginUserDetails: any = userDetials;

    await determineIps();
    let ipAddress = GetItemFromStorage("IP");
    if (!ipAddress) {
      ipAddress = await publicIp.v4();
    }
    const DomainName = `${LoginUserDetails?.domain_name}:${config().DOMAIN_NAME_PORT}`;
    const username = LoginUserDetails?.ext;
    const displayName = LoginUserDetails?.profileName;
    const password = LoginUserDetails?.dp_password;
    const ip = ipAddress;

    const configuration = {
      //wsServers: config().CALL_SERVER_WSS_URL,
      wsServers: wssUrl,
      viaHost: ip,
      uri: username + "@" + DomainName,
      userAgentString: config().CALL_SERVER_USER_AGENT,
      traceSip: true,
      register: true,
      authorizationUser: username,
      password: password,
      turnServers: {
        urls: config().CALL_SERVER_STUN_URL,
        username: config().CALL_SERVER_STUN_USERNAME,
        password: config().CALL_SERVER_STUN_PASSWORD,
      },
      displayName: displayName,
      callId: username,
      host: ip,
    };
    console.log('Got001 [SIP - CALL LOG] - CONFIGURATION', configuration)
    let UA = await Registration(configuration);

    UA.on("accepted", function (reason: any) {
      if (reason.method === "REGISTER") {
        console.log("Got001 - [SIP - CALL LOG] ----------registration success------------");
        const reg = GetItemFromStorage('register')
        if ([reg].includes("1")) {
          const registerDetails: any = store.getState().callPopUpDetails;
          let { agentRegisterDetails } = registerDetails
          console.log("Got001 - [SIP - CALL LOG] agentRegisterDetails>>>>>>", agentRegisterDetails)
          callChatService.io.emit("agent_register_request", {
            ...agentRegisterDetails, status: 'success'
          });
          dispatch(CallPopUpAgentActions.setagentRegisterDetails({}));
          localStorage.removeItem('register')
        }
        dispatch(CallUserAgentActions.setLoginuserUserAgent(UA));
        inviteBinding(UA);
      }
    });

    UA.transport.on("disconnected", () => {
      console.log("Got001 - [SIP - CALL LOG] 🔴 WebSocket disconnected");
    });

    UA.transport.on("connected", () => {
      console.log("Got001 - [SIP - CALL LOG] 🟢 WebSocket reconnected");
      isUAInitializing = true;
      createCallConnection()
    });
  };

  const inviteBinding = (UA: any) => {
    UA.on("registrationFailed", function (reason: any) { 
      console.log("Got001 - [SIP - CALL LOG] 🔴 registrationFailed");
    });

    UA.on("referInviteSent", function (e: any) { 
      console.log("Got001 - [SIP - CALL LOG] 🔴 registrationFailed");
    });

    UA.on("invite", async function (rsession: any) {
      try {
        console.log("Got001 - [SIP - CALL LOG] GOT INVITE", rsession);
        const campaign = store.getState().outboundcampaign;
        const popUpDetails: any = store.getState().callPopUpDetails;

        console.log('[SIP - CALL LOG] Auto answer state:', (campaign?.incomingCallInfo?.outboundCampaign || campaign?.userCallInfo) && campaign?.autoAnswer)

        let sessionCompleteData = rsession.incomingRequest.message.data;
        let subStringSession = sessionCompleteData.split("v=0")[0];
        let sessionval = subStringSession.split("ExtraRemote-Info:")[0];
        let TransSession = subStringSession.split("ExtraRemote-Info:")[1].trim();
        let callSession = sessionval.split("iuid:")[1];

        let sessionId = "";
        let getAgentType = "";


        if (TransSession.includes("CCAAS-SESSION-ID:")) {
          sessionId = TransSession.split("CCAAS-SESSION-ID:")[1];
          console.log('[SIP - CALL LOG]  sessionId:', sessionId);
          getAgentType = "AGENT";
        } else {
          sessionId = callSession;
          getAgentType = "EXTERNAL";
        }

        /* if (sessionId?.trim() === campaign?.incomingCallInfo?.session_id) {
          console.log('[SIP - CALL LOG] same sessionID:', sessionId)
        } else {
          agentBusy(rsession)
          console.log('[SIP - CALL LOG] agentBusy:', Object.keys(popUpDetails?.incomingCallDetail ?? {}).length === 0, window.location.pathname)
          if (Object.keys(popUpDetails?.incomingCallDetail ?? {}).length === 0 && window.location.pathname !== "/chatscreenagent") {
            await presenceChangeToReady()
            dispatch(outboundCampaignSliceAction.clearIncomingCallInfo());
          } 
          return;
        } */

        const micState = await waitForMicrophonePermission();
        console.log('micState :', micState)
        if (micState === "granted") {
          console.log("Got001 - [SIP - CALL LOG] ✅ Proceed with the call setup...");
        }
        /*  else {
           console.log('[SIP - CALL LOG] micState disable')
           agentBusy(rsession)
           return;
         } */

        dispatch(CallPopUpAgentActions.clearIncomingCallDetail());
        dispatch(CallPopUpAgentActions.setCloseCall(false));
        dispatch(CallPopUpAgentActions.isCallAccepted());

        let { isCallAccepted } = popUpDetails;

        if (window.location.pathname !== "/login" && window.location.pathname !== "/") {
          if (!isCallAccepted) {
            if ("Notification" in window) {
              Notification.requestPermission().then((permission) => {
                if (permission === "granted") {
                  var notificationBrowser = new Notification("CCAAS-Worktual", {
                    body: `Call From ${campaign?.incomingCallInfo?.customerName ?? "New Customer"} -  ${FromCallerName} in worktual contact center`,
                    icon: "",
                  });
                  console.log("Got001 - [SIP - CALL LOG] got invite requestPermission Notification");

                  notificationBrowser.onclick = function (event) {
                    event.preventDefault();

                    window.parent.focus();

                    notificationBrowser.close();
                  };
                }
              });
            }

            dispatch(CallPopUpAgentActions.setSessionId(sessionId.trim()));

            let FromCallerName = rsession.remoteIdentity.uri.normal.user;
            let Details: any = {};
            let queueName: any = "";
            let useragent: any = rsession;
            const guid = uuidv4();
            let medium: string = "audio";
            let bound: string = "IN";
            let fromcaller: string = useragent?.remoteIdentity?.uri?.normal?.user ?? "New User";
            dispatch(getCallNecessaryDetails({ contact: rsession.remoteIdentity.uri.normal.user, sessionId: sessionId.trim() }))
              .unwrap()
              .then((response: any) => {
                if (response?.contact?.code === "ECONNABORTED" || response?.contact?.data?.statusCode !== 200) {
                  FromCallerName = rsession.remoteIdentity.uri.normal.user;
                  Details = {};
                } else {
                  FromCallerName =
                    response.contact.data.getContactNumberRes.length > 0 ? response.contact.data.getContactNumberRes[0].firstName : rsession.remoteIdentity.uri.normal.user;
                  Details = response.contact.data.getContactNumberRes.length > 0 ? response.contact.data.getContactNumberRes[0] : {};
                }
                if (response?.sessionDetail?.code === "ECONNABORTED" || response?.sessionDetail?.data?.statusCode !== 200) {
                  queueName = "";
                  declineCallFunction(rsession);
                  CallPopUpAgentActions.setWholeData({
                    acceptCallRoom: false,
                    callRoomInfo: "",
                    callSessionId: "",
                    callSessionDetailswhilePopup: "",
                    isCallAccepted: false,
                  });
                  notification.info({
                    message:
                      response?.sessionDetail?.code === "ECONNABORTED"
                        ? `A call was rejected due to some technical issue.`
                        : `Error: Unable to accept the call. The call is routed to another agent.`,
                    placement: "topRight",
                    className: "toastNotification error",
                    duration: 3,
                    top: 70,
                  });
                } else {
                  console.log("Got001 - [SIP - CALL LOG] Worktual CALL DID COME HERE");

                  queueName = response.sessionDetail.data.getSessionDetailsRes.length > 0 ? response.sessionDetail.data.getSessionDetailsRes[0].queueName : "";

                  let CalluserDetails = {
                    userAgent: useragent,
                    medium: medium,
                    bound: bound,
                    contact: {},
                    fromcaller: fromcaller,
                    fromCallerName: FromCallerName,
                    guid: guid,
                    agentType: TransSession?.includes("CCAAS-SESSION-ID:") ? "SECONDARY" : "PRIMARY",
                    typeOf: getAgentType,
                    contactDetails: Details,
                    sessionId: sessionId?.trim(),
                    queueName: TransSession?.includes("CCAAS-SESSION-ID:") ? (queueName !== "" ? queueName : "Tranfered call") : queueName ?? "",
                    isCustomer: TransSession?.includes("CCAAS-SESSION-ID:") ? false : true,
                  };
                  // if ((campaign?.incomingCallInfo?.outboundCampaign || campaign?.userCallInfo) && campaign?.autoAnswer) {
                  //   callPopUpFunction(false, CalluserDetails, false);
                  // } else {
                    callPopUpFunction(true, CalluserDetails, false);
                    let ringer: any = document.getElementById("ringer");
                    console.log(ringer, "ringer");

                    var promisesRing: any = ringer.play();
                    if (promisesRing !== undefined) {
                      promisesRing.then(() => {
                        ringer.play();
                      })
                        .catch((error: any) => {
                          ringer.play();
                        });
                    }
                  // }
                  setUpListeners(useragent, fromcaller.toString(), medium, bound, "", guid, false);
                  console.log('outboundCampaign acceptCallFunction :', isCallAccepted, "campaign?.incomingCallInfo?.outboundCampaign", campaign?.incomingCallInfo?.outboundCampaign, "campaign?.autoAnswer", campaign?.autoAnswer, "campaign?.userCallInfo ", campaign?.userCallInfo)
                  // if ((campaign?.incomingCallInfo?.outboundCampaign || campaign?.userCallInfo) && campaign?.autoAnswer) {
                  //   acceptCallFunction(useragent, fromcaller.toString())
                  //   updateStatusState()
                  // }
                }
              }).catch((err: any) => {
                console.log('[SIP - CALL LOG] got invite catch:', err)
              });
          }
        }
      } catch (error) {
        console.log("Got001 - [SIP - CALL LOG] invite err:", error)
      }
    });
  };

  const waitForMicrophonePermission = async (): Promise<"granted" | "denied" | "prompt"> => {
    try {
      const permissionStatus = await navigator.permissions.query({ name: "microphone" as PermissionName });

      if (permissionStatus.state === "granted") {
        console.log("✅ Microphone already granted.");
        return "granted";
      }

      if (permissionStatus.state === "prompt") {
        try {
          console.log("Got001 - [SIP - CALL LOG] 🔄 Requesting microphone access...");
          await navigator.mediaDevices.getUserMedia({ audio: true });
          console.log("Got001 - [SIP - CALL LOG] ✅ Microphone granted after prompt.");
          return "granted";
        } catch (err) {
          console.warn("❌ User denied microphone access.");
          return "denied";
        }
      }

      if (permissionStatus.state === "denied") {
        console.warn("❌ Microphone permission is blocked. Waiting for user to change it...");

        return new Promise((resolve) => {
          permissionStatus.onchange = async () => {
            console.log("Got001 - [SIP - CALL LOG] 🔁 Permission changed:", permissionStatus.state);

            if (permissionStatus.state === "granted") {
              console.log("Got001 - [SIP - CALL LOG] ✅ Microphone permission now granted.");
              resolve("granted");
            } else if (permissionStatus.state === "denied") {
              resolve("denied");
            } else {
              resolve("prompt");
            }
          };

          // Optionally show manual steps to user
          alert(
            `Microphone access is blocked.\n\nTo enable:\n1. Click the 🔒 icon in the address bar\n2. Site settings → Microphone: Allow\n3. Refresh the page`
          );
        });
      }

      return permissionStatus.state;
    } catch (err) {
      console.error("Error checking microphone permission:", err);
      return "denied";
    }
  };


  const makeCallFunction = (sipId: any) => {
    const popUpDetails: any = store.getState().callPopUpDetails;

    const callLoginUserAgent: any = store.getState().callLoginUserAgent;
    let { incomingCallDetail, queueName } = popUpDetails;

    let { userAgent } = callLoginUserAgent;
    const LoginCcaasUserDetails: any = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
    const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
    const LoginUserDetails: any = userDetails;
    const uri = `sip:${sipId}@${LoginUserDetails.domain_name}`;

    let name = queueName !== "" ? queueName : LoginUserDetails.profileName;

    let useragent = MakeCall(userAgent, uri, "audio", name);
    const { agentStatus } = store.getState().agentState;
    const { users } = store.getState().userList;
    let status: any = null
    if (agentStatus?.length > 0) {
      [status] = agentStatus.filter((i: any) => { return "Busy" === i?.statusName?.trim() })
    }
    let enableStatus: any = null
    if (users.length > 0) {
      [enableStatus] = users?.filter((i: any) => { return LoginCcaasUserDetails?.emailId === i?.emailId })
    }
    console.log('[SIP - CALL LOG]  presenceService 12', status, enableStatus);
    presenceService.io.emit("updatestate_backend", {
      domainId: LoginUserDetails?.domainId,
      isVoice: (enableStatus?.voice === 1 && status?.isVoice === 1) ? 1 : 0,
      isVoiceCallTransfer: status?.isVoiceCallTransfer ?? 0,
      isChat: (enableStatus?.chat === 1 && status?.isChat === 1) ? 1 : 0,
      isChatTransfer: status?.isChatTransfer ?? 0,
      isEmail: (enableStatus?.email === 1 && status?.isEmail === 1) ? 1 : 0,
      isEmailTransfer: status?.isEmailTransfer ?? 0,
      stateTime: Math.floor(Date.now() / 1000),
      statusName: "Busy",
      ext: LoginUserDetails?.ext,
      email: LoginUserDetails?.Email,
      userId: LoginCcaasUserDetails?.UserID,
      routingProfileId: LoginCcaasUserDetails?.routing_profile_id,
      userName: LoginCcaasUserDetails?.UserName,
      roleId: LoginCcaasUserDetails?.roleid,
      agentStatus: 0,
      skill: JSON.parse(enableStatus?.addSkill ?? '[]'),
      routingMethod: enableStatus?.routingMethod ?? 0,
      inboundCall: enableStatus?.inboundCall,
      outboundCampaignCall: enableStatus?.outboundCampaignCall,
      is_outbound_campaign_specific_agent: enableStatus?.is_outbound_campaign_specific_agent
    });
    let data = {
      ext: LoginUserDetails?.ext,
      domainId: LoginUserDetails?.domainId
    };
    callChatService.io.emit("agent_ready_for_queue_users", data);
    WhatsappService.post(data, `/send_agent_status_queue`);
    SocialmediaServices.post(data, `/send_agent_status_queue_facebook`);
    SocialmediaServices.post(data, `/send_agent_status_queue_instagram`);
    setUpListeners(useragent, sipId, "audio", "OUT", "", incomingCallDetail.guid, false);
  };

  const CallOutboundCampaignFunction = (data: any, contactDetails: any) => {
    try {
      const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
      const LoginCcaasUserDetails: any = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
      const LoginUserDetails: any = userDetails;
      const callLoginUserAgent: any = store.getState().callLoginUserAgent;
      let { userAgent } = callLoginUserAgent;
      const uri = `sip:${data?.customer}@${LoginUserDetails.domain_name}`;
      let name = LoginUserDetails.profileName;

      let ccaasFeatreReq = [
        `CCAAS-FEATURE-REQ:OUTBOUND_CAMPAIGN`,
        `CCAAS-SESSION-ID:${data?.session_id}`,
        `CCAAS-CALLER-TYPE:AGENT`,

      ];

      let useragent = MakeCallOutboundCampiagn(userAgent, uri, "audio", name, ccaasFeatreReq);

      const { users } = store.getState().userList;
      let enableStatus: any = null
      if (users.length > 0) {
        [enableStatus] = users?.filter((i: any) => { return LoginCcaasUserDetails?.emailId === i?.emailId })
      }
      console.log('[SIP - CALL LOG]  presenceService outbound campaign call:', enableStatus);
      presenceService.io.emit("updatestate_backend", {
        domainId: LoginUserDetails?.domainId,
        isVoice: 0,
        isVoiceCallTransfer: 0,
        isChat: 0,
        isChatTransfer: 0,
        isEmail: 0,
        isEmailTransfer: 0,
        stateTime: Math.floor(Date.now() / 1000),
        statusName: "Busy",
        ext: LoginUserDetails?.ext,
        email: LoginUserDetails?.Email,
        userId: LoginCcaasUserDetails?.UserID,
        routingProfileId: LoginCcaasUserDetails?.routing_profile_id,
        userName: LoginCcaasUserDetails?.UserName,
        roleId: LoginCcaasUserDetails?.roleid,
        agentStatus: 0,
        skill: JSON.parse(enableStatus?.addSkill ?? '[]'),
        routingMethod: enableStatus?.routingMethod ?? 0,
        inboundCall: enableStatus?.inboundCall,
        outboundCampaignCall: enableStatus?.outboundCampaignCall,
is_outbound_campaign_specific_agent: enableStatus?.is_outbound_campaign_specific_agent
      });
      let queuedata = {
        ext: LoginUserDetails?.ext,
        domainId: LoginUserDetails?.domainId
      };
      try {
        callChatService.io.emit("agent_ready_for_queue_users", queuedata);
        WhatsappService.post(data, `/send_agent_status_queue`);
        SocialmediaServices.post(data, `/send_agent_status_queue_facebook`);
        SocialmediaServices.post(data, `/send_agent_status_queue_instagram`);
      } catch (error) {
        console.log('[SIP - CALL LOG] Api error:', error)
      }
      setUpListeners(useragent, data?.customer, "audio", "OUT", "", uuidv4(), true);
    } catch (error) {
      console.log('[SIP - CALL LOG] CallOutboundCampaignFunction err:', error)
    }
  };

  const CallTransferFunction = (ext: any) => {
    const dialPadDetails: any = store.getState().callPopUpDetails;
    const callLoginUserAgent: any = store.getState().callLoginUserAgent;

    let { userAgent } = callLoginUserAgent;
    const chatReducer: ChatState = store.getState().chatReducer;
    let { incomingCallDetail } = dialPadDetails;
    const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
    const LoginUserDetails: any = userDetails;

    let uri = "sip:" + ext + "@" + LoginUserDetails.domain_name;

    let ccaasFeatreReq = [
      `CCAAS-FEATURE-REQ:TRANSFER`,
      `CCAAS-SESSION-ID:${chatReducer?.currentSession?.sessionId}`,
      `CCAAS-CALLER-TYPE:AGENT`,
      `CCAAS-TRANSFER-TYPE:${dialPadDetails?.transfer_type}`, // QUEUE, AGENT, EXTERNAL
    ];

    let useragent = MakeReInviteCall(userAgent, uri, "audio", "unKnown", ccaasFeatreReq);

    setUpListeners(useragent, LoginUserDetails.ext, "audio", "OUT", "Transfer", incomingCallDetail.guid, false);
  };

  const setUpListeners = (thissession: any, callerSip: string, medium: string, bound: string, monitor?: any, sessionGet?: any, obc?: any) => {
    const ringer: any = document.getElementById("ringer");
    try {
      clearInterval(listenInterval);
      thissession.on("accepted", function (e: any) {
        console.log("Got001 - [SIP - CALL LOG] connected e", e);
        console.log("Got001 - [SIP - CALL LOG] connected thissession", thissession);
        console.log("Got001 - [SIP - CALL LOG] connected callerSip", callerSip);

         const popUpDetails: any = store.getState().callPopUpDetails;

        let { incomingCallDetail, callDetails, isTrackAgent } = popUpDetails;

        let useragent: any = thissession;
        let fromcaller: string = thissession.remoteIdentity.uri.normal.user;
        let tocaller_id = callerSip;
        let storeData: any = {
          guid: sessionGet,
          useragent: useragent,
          from: fromcaller,
          to: tocaller_id.toString(),
          muteState: false,
          holdState: false,
          medium: "audio",
          bound: bound,
          agentType: "PRIMARY",
          contact: [],
          isTransfer: monitor,
          isCurrent: true,
          isCustomer: false,
          isNewCall: true,
          isConference: false,
          callStatus: "Ringing",
          callType: "direct",
          typeOf: monitor === "Transfer" ? "AGENT" : "EXTERNAL",
          outboundCampaign: obc ?? false
        };

        if (bound === "OUT") {
          console.log("Got001 - [SIP - CALL LOG] Entering - OUT");
          // dialPadChanges(false, false, false, false, true, true);
          if (e !== undefined && e.toString().includes("call-connected-info")) {
            let callInfo: any = new DOMParser().parseFromString(e, "text/xml");
            let connectionStatus: string = callInfo.getElementsByTagName("call-connected-info")[0].getAttribute("callstatus");
            if (connectionStatus === "connected") {
              if (monitor === "Transfer") {
                dispatch(CallPopUpAgentActions.updateCallState("accepted"));
                dialPadChanges(false, true, false, false, true, true);

                dispatch(CallPopUpAgentActions.timerForTransferAgent());
              } else {
                if (callDetails.length > 1) {
                  dialPadChanges(false, true, false, false, true, true);
                  dispatch(CallPopUpAgentActions.updateCallState("accepted"));
                } else {
                  if (storeData.typeOf === "AGENT") {
                    // }else if(callDetails.length===1&&storeData.typeOf==="EXTERNAL"){
                    if (window.location.pathname === "/chatscreenagent") {
                      dialPadChanges(false, false, false, false, true, true);
                    } else {
                      dialPadChanges(false, true, false, false, true, true);
                    }
                  }
                  dispatch(CallPopUpAgentActions.updateCallState("accepted"));
                  navigate("/chatscreenagent");
                }
                callTimerFunc(false);
              }
              if (isTrackAgent) {
                incomingCallUserData(false, storeData);
              }
            }
          } else {
            let contactDetails: any;
            if (callDetails.length === 1) {
              contactDetails = incomingCallDetail.contactDetails;
            } else {
              contactDetails = getUser(fromcaller) ?? {};
              if (!contactDetails.hasOwnProperty("ext")) {
                getContactDetails(fromcaller, 'Call').then((res: any) => {
                  if (res?.data?.statusCode === 200) {
                    contactDetails = res?.data?.getContactNumberRes[0];
                  } else {
                    contactDetails.calledPersonDetails = {};
                  }
                });
              }
            }

            storeData["contactDetails"] = contactDetails;
            if (monitor === "Transfer") {
              dispatch(CallPopUpAgentActions.pushCallDetails(storeData));
              dialPadChanges(false, true, false, false, false, false);
            } else if (isTrackAgent) {
              dialPadChanges(false, false, false, false, false, false);
              incomingCallUserData(false, storeData);
            } else {
              if (callDetails.length >= 1) {
                //changed
                dialPadChanges(false, true, false, false, false, false);
                dispatch(CallPopUpAgentActions.pushCallDetails(storeData));
              } else {
                dispatch(CallPopUpAgentActions.pushCallDetails(storeData));
                dispatch(CallPopUpAgentActions.setCallingval(true));
              }
            }
          }
        } else if (monitor === "LISTEN" || "BARGE" || "WHISPER") {
          if (e !== undefined && e.toString().includes("call-connected-info")) {
            let callInfo: any = new DOMParser().parseFromString(e, "text/xml");
            let connectionStatus: string = callInfo.getElementsByTagName("call-connected-info")[0].getAttribute("callstatus");

            if (connectionStatus === "connected") {
              dispatch(CallPopUpAgentActions.TrackDataUpdate());
              if (monitor === "LISTEN") {
                listenInterval = setInterval(() => {
                  dispatch(CallPopUpAgentActions.agentTrackTimer());
                }, 1000);
              }
            }
          } else {
            if (monitor === "Transfer") {
            }
            dispatch(CallPopUpAgentActions.MonitorType(monitor));
          }
        }
      });
      thissession.on("message", function (e: any) { 
        console.log("Got001 - [SIP - CALL LOG] message", e)
      });

      thissession.on("referInviteSent", function (e: any) { 
        console.log("Got001 - [SIP - CALL LOG] referInviteSent", e)
      });

      thissession.on("progress", function (e :any) { 
        console.log("Got001 - [SIP - CALL LOG] progress", e )
      });

      thissession.on("bye", function (e :any) {
        console.log("Got001 - [SIP - CALL LOG] bye calling", e )


        const popUpDetails: any = store.getState().callPopUpDetails;
        let { incomingCallDetail, callDetails, isTrackAgent, trackAgentDetail, ShowCallerDetails } = popUpDetails;
        const chatReducer = store.getState().chatReducer;
        let { sessionList } = chatReducer;

        console.log("Got001 - [SIP - CALL LOG] bye calling   isTrackAgent", isTrackAgent, sessionList);

        if (isTrackAgent) {
          if (ShowCallerDetails && trackAgentDetail?.sessionId) {
            dispatch(ChatActions.sessionRemoveAfterEnd(trackAgentDetail?.sessionId));
            if (sessionList.length == 0)
              navigate("/allactivity");
          }

          transferChanges(false, {});
          dispatch(CallPopUpAgentActions.MonitorType(""));
          clearInterval(listenInterval)
        }
        if (incomingCallDetail.callStatus === "Ringing") {
          ringer.pause();
          if (callDetails.length >= 2) {
            CallUnHold(callDetails[callDetails.length - 2].useragent);
          } else if (incomingCallDetail.bound === "OUT" && callDetails.length === 1) {
            dispatch(CallPopUpAgentActions.setSpliceCallDetails(sessionGet));
          }
        }
      });

      thissession.on("trackAdded", function () {
        const popUpDetails: any = store.getState().callPopUpDetails;
        let { isTrackAgent } = popUpDetails;
        if (isTrackAgent) {
          dialPadChanges(false, false, false, false, false, false);
        }
        let remoteVideo: any = document.getElementById("remoteVideo");
        let remoteStream = new MediaStream();
        var pc = thissession.sessionDescriptionHandler.peerConnection; // Gets remote tracks
        console.log("Got001 - [SIP - CALL LOG] pc.getReceivers >>>>>>", pc.getReceivers);
        if (pc.getReceivers) {
          pc.getReceivers().forEach(function (receiver: any) {
            console.log('[SIP - CALL LOG] receiver----', receiver)
            var track = receiver.track;
            if (track) {
              remoteStream.addTrack(track);
            }
          });
          remoteVideo.srcObject = remoteStream;
        }
      });

      thissession.on("reject", function (response: any, cause: any) {

        console.log('[SIP - CALL LOG] REJECT - RESPONSE', response)
        console.log('[SIP - CALL LOG] REJECT', cause)

        if (cause === "Not Found") {
        } else if (cause === "SIP Failure Code") {
        } else if (cause === "Temporarily Unavailable") {
        } else if (cause === "Canceled") {
        }
      });

      thissession.on("terminated", async function (data: any, cause: any) {

        console.log('[SIP - CALL LOG] TERMINATED DATA', data)
        console.log('[SIP - CALL LOG] TERMINATED CAUSE', cause)
        
        const dispositionData: any = store.getState().dispositionData;
        let { started, storeInterval } = dispositionData;
        const popUpDetails: any = store.getState().callPopUpDetails;
        let { incomingCallDetail, callDetails, isMergeButton, isTrackAgent, mergedCall, isTransferSuccess, trackAgentDetail } = popUpDetails;
        const campaign: any = store.getState().outboundcampaign

        const roomData: any = store.getState().chatReducer;
        const { storeIntentForClearTimer, callSessionId }: any = roomData;
        let fromcaller: any;
        let ringer: any = document.getElementById("ringer");
        ringer.pause();
        if (data !== undefined && !isTrackAgent) {
          if (data?.statusCode !== 408) {
            fromcaller = typeof data.from.uri.normal.user === "string" ? data.from.uri.normal.user : data.from.uri.normal.user.toString();
          }
          console.log("Got001 - [SIP - CALL LOG] TERMINATE by", fromcaller);
          if (cause === "Canceled") {
            //agent not attended
            console.log(
              "Got001 - [SIP - CALL LOG] TERMINATE  callSessionId", callSessionId, 
              "roomData?.incomingCallInfo?.outboundCampaign", campaign?.incomingCallInfo?.outboundCampaign, 
              "roomData?.autoAnswer", campaign?.autoAnswer
            );
            dispatch(ChatActions.setCallSessionList({ state: true, sessionId: callSessionId ?? "" }));
            dispatch(CallPopUpAgentActions.NotAttendedCall());
            dispatch(CallPopUpAgentActions.clearIncomingCallDetail());
            // dispatch(outboundCampaignSliceAction.clearIncomingCallInfo());

            dispatch(CallPopUpAgentActions.setCloseCall(true));
            if (campaign?.incomingCallInfo?.outboundCampaign && !campaign?.autoAnswer) {
              presenceChangeToReady()
            }

          } else if (cause === "BYE") {
            console.log("Got001 - [SIP - CALL LOG] cause == BYE");

            ringer.pause();
            if (isTrackAgent) {
              console.log("Got001 - [SIP - CALL LOG] - isTrackAgent");
              transferChanges(false, {});
              dispatch(CallPopUpAgentActions.MonitorType(""));
              clearInterval(listenInterval)
            } else if (callDetails.length > 1) {
              console.log("Got001 - [SIP - CALL LOG] - OUT");
              if (incomingCallDetail.callStatus === "Ringing" && incomingCallDetail.bound === "OUT") {
                dispatch(CallPopUpAgentActions.CallTransferingpopup(true));
                dispatch(CallPopUpAgentActions.terminateNormal(fromcaller));
                dispatch(CallPopUpAgentActions.updateTransferType({ transfer_type: "" }));
              } else if (incomingCallDetail.callStatus === "accepted" && callDetails.length === 2) {
                console.log("Got001 - [SIP - CALL LOG] >>>>>>>>>>>>>>>>>>>",isMergeButton, incomingCallDetail, callDetails);
                // dispatch(CallPopUpAgentActions.removeCallDetails(incomingCallDetail));

                if (isMergeButton === false) {
                  dispatch(CallPopUpAgentActions.forMergeBye(fromcaller));
                }
                else {
                  dispatch(CallPopUpAgentActions.terminateNormal(fromcaller));
                  dispatch(CallPopUpAgentActions.setScondaryagent(incomingCallDetail));
                  CallUnHold(callDetails[callDetails.length - 2].useragent);
                  //dispatch(outboundCampaignSliceAction.clearIncomingCallInfo());
                }
              }
            } else {
              if (incomingCallDetail.isConference) {
                console.log("Got001 - [SIP - CALL LOG] incomingCallDetail.isConference ",incomingCallDetail.isConference);
                console.log("Got001 - [SIP - CALL LOG]", mergedCall, started);

                const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
                console.log("Got001 - [SIP - CALL LOG] Geting", fromcaller === userDetails.ext);
                if (fromcaller !== userDetails.ext && `${fromcaller}`.length === 3) {
                  // if (!started) {
                  //   clearInterval(storeInterval);
                  //   let InterValData = setInterval(() => {
                  //     dispatch(dispositionSliceActions.startDispositionTimer());
                  //   }, 1000);
                  //   dispatch(dispositionSliceActions.storeIntervalData(InterValData));
                  // }
                  // dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: true }));
                  hassAccess('Disposition/regenerate') && summarySubjectHandlerForCall(callSessionId, dispatch, 0)
                  dispatch(ChatActions.setCallSessionList({ state: true, sessionId: callSessionId ?? "" }));
                  dispatch(CallPopUpAgentActions.closemergedCall());
                }
                else {
                  console.log('[SIP - CALL LOG] incomingCallDetail.callType ---------', incomingCallDetail.callType)
                  if (incomingCallDetail.callType === "conCall" && incomingCallDetail?.contact?.length > 0) {
                    const pstn = incomingCallDetail?.contact.filter((i: any) => i.to === fromcaller)
                    console.log('[SIP - CALL LOG] incomingCallDetail---------', incomingCallDetail)
                    console.log('[SIP - CALL LOG] pstn---------', pstn)
                    if (pstn.length > 0) {
                      // dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: true }));
                      hassAccess('Disposition/regenerate') && summarySubjectHandlerForCall(callSessionId, dispatch, 0)
                      dispatch(ChatActions.setCallSessionList({ state: true, sessionId: callSessionId ?? "" }));
                    }
                  }
                }
                // dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: true }));
                dispatch(CallPopUpAgentActions.forSipFailiure(fromcaller));
              } else {
                try {
                  console.log("Got001 - [SIP - CALL LOG] in >>>>>>>>>", callDetails, callDetails.length, incomingCallDetail);
                  const { ShowCallerDetails }: any = store.getState().callPopUpDetails;
                  if (callDetails.length !== 0) {
                    // if (!mergedCall) {
                    //   if (!started) {
                    //     clearInterval(storeInterval);
                    //     let InterValData = setInterval(() => {
                    //       dispatch(dispositionSliceActions.startDispositionTimer());
                    //     }, 1000);
                    //     dispatch(dispositionSliceActions.storeIntervalData(InterValData));
                    //   }
                    //   dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: true }));
                    // }
                    if (callDetails.length === 1 && callDetails?.[0]?.bound === "OUT" && callDetails?.[0]?.isTransfer == "") {
                      console.log("in out >>>>>>>>>", callDetails);

                      // dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: true }));
                      hassAccess('Disposition/regenerate') && summarySubjectHandlerForCall(callSessionId, dispatch, 0)
                      dispatch(ChatActions.setCallSessionList({ state: true, sessionId: callSessionId ?? "" }));
                      //dispatch(outboundCampaignSliceAction.clearIncomingCallInfo());

                    }
                    else if (fromcaller && callDetails.length === 1 && callDetails?.[0]?.AllAgent?.length > 0) {
                      if (callDetails?.[0]?.AllAgent?.includes(fromcaller)) {
                        // dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: true }));
                        hassAccess('Disposition/regenerate') && summarySubjectHandlerForCall(callSessionId, dispatch, 0)
                        dispatch(ChatActions.setCallSessionList({ state: true, sessionId: callSessionId ?? "" }));
                      }
                    }
                    // dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: true }));
                    dispatch(CallPopUpAgentActions.terminateNormal(fromcaller));
                    //dispatch(outboundCampaignSliceAction.clearIncomingCallInfo());

                    // clearInterval(storeIntentForClearTimer);
                  } else {
                    if (!ShowCallerDetails) {
                      // dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: true }));
                      dialPadChanges(false, false, false, false, false, false);
                      hassAccess('Disposition/regenerate') && summarySubjectHandlerForCall(callSessionId, dispatch, 0)
                      dispatch(ChatActions.setCallSessionList({ state: true, sessionId: callSessionId ?? "" }));
                    }
                  }
                } catch (error) {
                  console.log('[SIP - CALL LOG] error------', error)
                }
              }
            }
          } else if (cause === "SIP Failure Code") {
            if (isTrackAgent) {
              transferChanges(false, {});
              dispatch(CallPopUpAgentActions.MonitorType(""));
              clearInterval(listenInterval)
            } else {
              dispatch(CallPopUpAgentActions.forSipFailiure(fromcaller));
              // dispatch(outboundCampaignSliceAction.clearIncomingCallInfo());

            }
          } else if (cause === "Unavailable") {
            if (callDetails.length === 1) {
              dispatch(CallPopUpAgentActions.forUnavailable());
              // dispatch(outboundCampaignSliceAction.clearIncomingCallInfo());

            } else {
              dispatch(CallPopUpAgentActions.forUnavailable());
              // dispatch(outboundCampaignSliceAction.clearIncomingCallInfo());
              let index = _.findIndex(callDetails, (e: any) => e.guid === incomingCallDetail.guid);
              if (index > -1) {
                CallUnHold(callDetails["useragent"]);
              }
            }
          } else if (cause === "Busy") {
            if (callDetails.length === 0) {
              if (isTrackAgent) {
                transferChanges(false, {});
                dispatch(CallPopUpAgentActions.MonitorType(""));
                clearInterval(listenInterval)
              } else {
                dispatch(CallPopUpAgentActions.clearCallForBusy());
                // dispatch(outboundCampaignSliceAction.clearIncomingCallInfo());

              }
            } else {
              if (isTrackAgent) {
                transferChanges(isTrackAgent, {});
                clearInterval(listenInterval)
                dispatch(CallPopUpAgentActions.MonitorType(""));

              } else {
                dispatch(CallPopUpAgentActions.clearCallForBusyforMore());
              }
            }
          } else if (cause === "Invalid status: 5") {
            console.log("TERMINATE  invalid status", callSessionId);
            dispatch(ChatActions.setCallSessionList({ state: true, sessionId: callSessionId ?? "" }));
            dispatch(CallPopUpAgentActions.NotAttendedCall());
            dispatch(CallPopUpAgentActions.clearIncomingCallDetail());
            // dispatch(outboundCampaignSliceAction.clearIncomingCallInfo());
            dispatch(CallPopUpAgentActions.setCloseCall(true));

          } else {
            dispatch(CallPopUpAgentActions.callEnded());
            presenceChangeToReady()
          }
        } else if (cause === "WebRTC Error") {
          console.log("TERMINATE  WebRTC Error", callSessionId);
          const micState = await waitForMicrophonePermission();
          dispatch(CallPopUpAgentActions.callEnded());
          presenceChangeToReady()
        } else {
          if (callDetails.length >= 1) {
            if (callDetails.length === 1) {
              // if (started) {
              clearInterval(storeInterval);
              let InterValData = setInterval(() => {
                dispatch(dispositionSliceActions.startDispositionTimer());
              }, 1000);
              dispatch(dispositionSliceActions.storeIntervalData(InterValData));
              // }
              // dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: true }));
              hassAccess('Disposition/regenerate') && summarySubjectHandlerForCall(callSessionId, dispatch, 0)
              dispatch(ChatActions.setCallSessionList({ state: true, sessionId: callSessionId ?? "" }));
              dispatch(CallPopUpAgentActions.terminateNormal(incomingCallDetail?.from));
              // dispatch(outboundCampaignSliceAction.clearIncomingCallInfo());

            }
          } else {
            // if (!started) {
            //   clearInterval(storeInterval);
            // let  InterValData = setInterval(() => {
            //     dispatch(dispositionSliceActions.startDispositionTimer());
            //   }, 1000);
            //   dispatch(dispositionSliceActions.storeIntervalData(InterValData));
            // }
            // console.log("called>>>>>>>>");
            // dispatch(dispositionSliceActions.setDispositionOpen());
            dispatch(CallPopUpAgentActions.callEnded());
          }
        }
        callPopUpFunction(false, {}, false);
      });
      thissession.on("failed", function (e: any, f: any) { });
    } catch (error) { }
  };

  const acceptCallFunction = async (userAgent: any, incomecaller: any) => {
    try {
      console.log(
      "Got001 - [SIP - CALL LOG] ACCEPTCALLFUNCTION ] useragent:",
       userAgent, 
       "incomecaller:", 
       incomecaller);
      const LoginCcaasUserDetails1 = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
      const { answeredDuration, incomingcallDetails } = store.getState().chatReducer;
      const popUpDetails: any = store.getState().callPopUpDetails;
      let { callSessionDetailswhilePopup, closeCall } = popUpDetails;
      const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
      const LoginUserDetails: any = userDetails;
      let guid = uuidv4();
      let tocaller_id = LoginUserDetails?.ext;
      let storeData = {
        guid: guid,
        useragent: userAgent,
        from: incomecaller,
        to: tocaller_id.toString(),
        muteState: false,
        holdState: false,
        medium: "audio",
        bound: "IN",
        contact: [],
        contactDetails: callSessionDetailswhilePopup.contactDetails,
        isCurrent: true,
        isNewCall: true,
        isConference: false,
        callStatus: "accepted",
        callType: "direct",
        agentType: callSessionDetailswhilePopup.agentType,
        typeOf: callSessionDetailswhilePopup.typeOf,
        sessionId: callSessionDetailswhilePopup?.sessionId?.trim(),
        queueName: callSessionDetailswhilePopup.queueName,
        callduration: "00:00:00",
        isCustomer: callSessionDetailswhilePopup.isCustomer,
      };

      // console.log("[SIP - CALL LOG] LOG ACCEPTCALLFUNCTION ] acceptCallFunction closeCall", closeCall);
      if (!closeCall) {
        await dispatch(CallPopUpAgentActions.pushCallDetails(storeData));
        console.log('[SIP - CALL LOG] [ACCEPTCALLFUNCTION ] Session Id', callSessionDetailswhilePopup?.sessionId?.trim(), storeData)
        dispatch(ChatActions.setCallSessionId(callSessionDetailswhilePopup?.sessionId?.trim() ?? ""));
        if (storeData.typeOf === "EXTERNAL") {
          try {
            CallAccept(userAgent, "audio", incomecaller);
            await dispatch(
              getNecessaryDetailswithsession({
                contact: callSessionDetailswhilePopup.fromcaller,
                sessionId: callSessionDetailswhilePopup?.sessionId.trim(),
                // channelType : 'Call'
              })
            )
              .unwrap()
              .then((res: any) => {
                if (res?.sessionDetail?.data.statusCode === 200) {
                  let chatSessionData: any = res?.sessionDetail?.data?.result[0];
                  chatSessionData.Number = chatSessionData.customerDetails;
                  chatSessionData.showState = storeData.typeOf === "EXTERNAL" ? true : false;
                  chatSessionData.queueName = callSessionDetailswhilePopup.queueName;
                  chatSessionData.queueId = incomingcallDetails?.qid;
                  if (res?.contact?.data?.statusCode === 200) {
                    chatSessionData.calledPersonDetails = res.contact?.data?.getContactNumberRes[0] || res.contact?.data?.getContactDetailsRes?.[0];
                    chatSessionData.calledPersonDetails.tags =
                      typeof res?.contact?.data?.getContactNumberRes[0]?.tags === "string"
                        ? JSON.parse(res?.contact?.data?.getContactNumberRes[0]?.tags?.trim().length > 0 ? res?.contact?.data?.getContactNumberRes[0]?.tags : "null") ?? []
                        : res?.contact?.data?.getContactNumberRes[0]?.tags;
                   
                  } else {
                    chatSessionData.calledPersonDetails = {};
                  }
                  dispatch(ChatActions.chatSessionList(chatSessionData));
                  dispatch(ChatActions.currentChatSession(chatSessionData));
                  callTimerFunc(true);
                  callPopUpFunction(false, {}, true);
                  navigate("/chatscreenagent");
                  dispatch(CallPopUpAgentActions.setDialPad())
                  dispatch(updateContactinSession({ sessionId: chatSessionData.sessionId, calledPersonDetails: chatSessionData.calledPersonDetails }));
                  // CallAccept(userAgent, "audio", incomecaller);
                  setUpListeners(userAgent, incomecaller, "audio", "IN", "", guid, false);
                  const body: any = {
                    CallHistoryId: chatSessionData?.CallHistoryId,
                    domainId: LoginUserDetails?.domainId,
                    AgentId: LoginCcaasUserDetails1?.UserID,
                    answeredDuration: answeredDuration ?? 0,
                  }
                  callChatService.callNotifyDialDuration(body);
                  try {
                    const agentID = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS)?.UserID
                    if (agentID) {
                      CallServices.get(`/incall?agentId=${agentID}&status=0`)
                    }
                  } catch (error) {
                    console.log(error)
                  }

                  try {
                    const coid = res.contact?.data?.getContactNumberRes?.[0]?.coid || res.contact?.data?.getContactDetailsRes?.[0]?.coid
                    getPriviousChannelSummary(dispatch, { coid, currentSessionId: callSessionDetailswhilePopup?.sessionId?.trim() })
                  } catch (error) {
                    console.log("getPriviousChannelSummary", error)
                  }
                  
                } else {
                  declineCallFunction(callSessionDetailswhilePopup.userAgent);
                  CallPopUpAgentActions.setWholeData({
                    acceptCallRoom: false,
                    callRoomInfo: "",
                    callSessionId: "",
                    callSessionDetailswhilePopup: "",
                    isCallAccepted: false,
                  });
                  notification.info({
                    message: `Error: Unable to accept the call. The call is routed to another agent.`,
                    placement: "topRight",
                    className: "toastNotification error",
                    duration: 3,
                    top: 70,
                  });
                }
              }).catch((err: any) => {
                console.log('acceptCallFunction catch err:', err)
              });
          } catch (error) {
            declineCallFunction(callSessionDetailswhilePopup.userAgent);
            CallPopUpAgentActions.setWholeData({
              acceptCallRoom: false,
              callRoomInfo: "",
              callSessionId: "",
              callSessionDetailswhilePopup: "",
              isCallAccepted: false,
            });

            notification.info({
              message: `Error: Unable to accept the call. The call is routed to another agent.`,
              placement: "topRight",
              className: "toastNotification error",
              duration: 3,
              top: 70,
            });
          }
        } else {
          callTimerFunc(false);
          callPopUpFunction(false, {}, true);
          dialPadChanges(false, true, false, false, false, false);
          CallAccept(userAgent, "audio", incomecaller);
          setUpListeners(userAgent, incomecaller, "audio", "IN", "", guid, false);
        }
      }
      let ringer: any = document.getElementById("ringer");
      ringer.pause();
      // dispatch(CallPopUpAgentActions.setCloseCall(false));
    } catch (error) {
      console.log('[SIP - CALL LOG] acceptCallFunction err:', error)
    }
  };

  const declineCallFunction = (userAgent: any) => {
    RejectCall(userAgent);
    callPopUpFunction(false, {}, false);
    let ringer: any = document.getElementById("ringer");
    ringer?.pause();
  };

  const CallMuteFunction = (incomingCallDetail?: any) => {
    Mute_AudioCall(incomingCallDetail.useragent);
    dispatch(CallPopUpAgentActions.setCallDetailsMuteState(incomingCallDetail.guid));
  };

  const superVisorMuteFunction = () => {
    const popUpDetails: any = store.getState().callPopUpDetails;
    let { trackAgentDetail } = popUpDetails;
    Mute_AudioCall(trackAgentDetail.useragent);
  };

  const superVisorUnMuteFunction = () => {
    const popUpDetails: any = store.getState().callPopUpDetails;
    let { trackAgentDetail } = popUpDetails;
    UnMute_AudioCall(trackAgentDetail.useragent);
  };

  const transferChanges = (isTrackAgent: any, trackAgentDetail: any) => {
    dispatch(
      CallPopUpAgentActions.TrackChanges({
        isTrackAgent: isTrackAgent,
        trackAgentDetail: trackAgentDetail,
      })
    );
  };
  const CallUnMuteFunction = (incomingCallDetail?: any) => {
    UnMute_AudioCall(incomingCallDetail.useragent);
    dispatch(CallPopUpAgentActions.setCallDetailsMuteState(incomingCallDetail.guid));
  };

  const CallHoldFunction = (incomingCallDetail?: any) => {
    CallHold(incomingCallDetail.useragent);
    dispatch(CallPopUpAgentActions.setCallDetailsHoldState(incomingCallDetail.guid));
  };

  const CallUnHoldFunction = (incomingCallDetail?: any) => {
    CallUnHold(incomingCallDetail.useragent);
    dispatch(CallPopUpAgentActions.setCallDetailsUnHoldState(incomingCallDetail.guid));
  };

  const sendDTMF = (incomingCallDetail: any, val: any) => {
    CallConference(incomingCallDetail.useragent, val);
  };

  const makeReInvite = (sessionId: any, type: any, AgentData: any) => {
    const popUpDetails: any = store.getState().callPopUpDetails;
    let { isTrackAgent } = popUpDetails;
    const callLoginUserAgent: any = store.getState().callLoginUserAgent;
    let { userAgent } = callLoginUserAgent;
    let ccaasFeatreReq = [`CCAAS-FEATURE-REQ: ${type}`, `CCAAS-SESSION-ID: ${sessionId}`, `CCAAS-CALLER-TYPE:SUPERVISOR`];
    //BARGE/LISTEN/WHISPER
    let medium: any;
    const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
    const LoginUserDetails: any = userDetails;
    var uri = `sip:${LoginUserDetails.ext}@${LoginUserDetails.domain_name}`;
    let useragent = MakeReInviteCall(userAgent, uri, medium, "unKnown", ccaasFeatreReq);
    setUpListeners(useragent, LoginUserDetails.ext, "audio", "ACTIVITY", type);
    let TrackAgentDetailsset: any = {};
    TrackAgentDetailsset.AgentData = AgentData;
    TrackAgentDetailsset.sessionId = sessionId;
    TrackAgentDetailsset.useragent = useragent;
    TrackAgentDetailsset.muteState = false;
    if (type === "LISTEN" && !isTrackAgent) {
      getCallSessionById(sessionId).then(async (response: any) => {
        if (response.data.statusCode === 200) {
          TrackAgentDetailsset.sessionDetails = response.data.result[0];
          TrackAgentDetailsset.sessionDetails.Number = response.data.result[0]?.customerNumber;
          TrackAgentDetailsset.sessionDetails.showState = true;
          TrackAgentDetailsset.sessionDetails.queueName = response.data.result[0].queueName;
          TrackAgentDetailsset.sessionDetails.notLive = true;
        } else {
          TrackAgentDetailsset.sessionDetails = {};
        }
        await getContactDetails(TrackAgentDetailsset.sessionDetails.Number, "Call")
          .then((res: any) => {
            if (res.data.statusCode === 200) {
              console.log(res, "resdatadatadata");
              TrackAgentDetailsset.sessionDetails.calledPersonDetails = res?.data?.getContactNumberRes.length > 0 ? res?.data?.getContactNumberRes[0] : {};
              TrackAgentDetailsset.sessionDetails.calledPersonDetails.tags =
                JSON.parse(res?.data?.getContactNumberRes[0]?.tags?.trim().length > 0 ? res?.data?.getContactNumberRes[0]?.tags : "null") ?? [];
            } else {
              TrackAgentDetailsset.sessionDetails.calledPersonDetails = {};
            }
            TrackAgentDetailsset.status = "connecting";
            TrackAgentDetailsset.Duration = "00:00:00";
            dispatch(CallPopUpAgentActions.TrackChanges({ isTrackAgent: true, trackAgentDetail: TrackAgentDetailsset }));
          });
      });
    }
  };
  const unregister = () => {
    const callLoginUserAgent: any = store.getState().callLoginUserAgent;
    let { userAgent } = callLoginUserAgent;
    try {
      Unregistration(userAgent);
      dispatch(CallUserAgentActions.reset());
      dispatch(CallPopUpAgentActions.reset());
      dispatch(CallPopUpAgentActions.reset());
    } catch (e: any) { }
  };

  const SupervisorEndCall = (useragent: any) => {
    EndCall(useragent);
  };

  const EndCallfunction = (endCallUserDetails: any) => {
    const popUpDetails: any = store.getState().callPopUpDetails;
    let { callDetails } = popUpDetails;
    if (callDetails.length === 0) {
      incomingCallUserData(false, {});
    }
    EndCall(endCallUserDetails.useragent);
    console.log("callDetails >>>>>>>", callDetails)
    if (callDetails.length > 1 && endCallUserDetails?.isCurrent === true) {
      dispatch(CallPopUpAgentActions.removeCallDetails(endCallUserDetails))
      CallUnHold(callDetails[callDetails.length - 2].useragent);
    }
  };


  const makeCallFunctionForAll = async (Input: any, transfertype: any, contactDetails?: any) => {
    const roomData: any = store.getState().chatReducer;
    const popUpDetails: any = store.getState().callPopUpDetails;
    let { incomingCallDetail, callDetails, isTransfer, queueName } = popUpDetails;
    const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
    const LoginCcaasUserDetails: any = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
    const LoginUserDetails: any = userDetails;
    if (Array.isArray(callDetails) && callDetails.length > 0) {
      dispatch(CallPopUpAgentActions.setIsCurrent());
    }
    let data: any = {
      callStatus: "Dialing",
      to: LoginUserDetails.ext.toString(),
      bound: "OUT",
      from: Input,
      callType: "direct",
      isCurrent: true,
      guid: uuidv4(),
      agnetType: "PRIMARY",
      typeOf: isTransfer ? "AGENT" : "EXTERNAL",
      contactDetails: contactDetails ?? {},
      isConference: false,
      isCustomer: (Array.isArray(callDetails) && contactDetails?.length) === 1 || isTransfer ? false : true,
      sessionId: roomData?.currentSession?.sessionId ?? "",
      queueName: (Array.isArray(callDetails) && contactDetails?.length) >= 1 ? incomingCallDetail.queueName : queueName ?? "",
      callduration: incomingCallDetail?.callduration
    };
    if (isTransfer) {
      let transferdata: any = {
        session_id: roomData?.currentSession?.sessionId,
        req_type: "AGENT_TRANSFER",
        transfer_type: transfertype, //1 - Agent 2 - PSTN 3-Queue
        ddi: parseInt(Input),
        email: (parseInt(contactDetails?.ext) === parseInt(Input)) ? contactDetails?.emailId : "",
        name: contactDetails?.UserName ? contactDetails?.UserName : contactDetails?.firstName ? contactDetails?.firstName : '',
        userId: `${contactDetails.UserID ?? ''}`
      };

      const transferfromdata = {
        domainId: LoginCcaasUserDetails?.domainId,
        toExt: parseInt(Input),
        fromExt: LoginCcaasUserDetails?.UserName,
        transferDataDetails: {
          id: uuidv4(),
          from: `${LoginCcaasUserDetails?.domainId}_${LoginCcaasUserDetails?.ext}`,
          to: roomData?.currentSession?.sessionId,
          sessionId: roomData?.currentSession?.sessionId,
          message: '<p>Transfer From ' + LoginCcaasUserDetails?.UserName + '</p>',
          sender: {
            uuid: LoginCcaasUserDetails?.UserID,
            Name: LoginCcaasUserDetails?.UserName,
            Email: LoginCcaasUserDetails?.emailId
          },
          isBot: false,
          isCustomer: false,
          isTransfer: true,
          messageType: 'Text',
          sendAt: Math.floor(Date.now() / 1000), // Convert to Unix timestamp in seconds
          chatIconLogo: '',
          timestamp: Math.floor(Date.now() / 1000) // Convert to Unix timestamp in seconds
        }
      };
      const transferTodata = {
        ...transferfromdata.transferDataDetails,
        message: '<p>Transfer To ' + contactDetails?.UserName + '</p>'
      }

      dispatch(CallPopUpAgentActions.updatecurrentState(incomingCallDetail.guid));
      dispatch(CallPopUpAgentActions.pushCallForTransfer(data));
      callChatService.transfer(transferdata);
      callChatService.transferFrom(transferfromdata);
      dispatch(CallPopUpAgentActions.setTransferto(transferTodata));
      CallTransferFunction(Input);
      callDetails.map((item: any) => CallHold(item.useragent));
    } else {
      makeCallReduxSet(data);
      makeCallFunction(Input);
    }
  };

  const makeCallReduxSet = (data: any) => {
    dialPadChanges(false, true, false, false, false, false);
    dispatch(CallPopUpAgentActions.pushCallDetails(data));
    incomingCallUserData(true, data);
  };
  const makeCallOutboundReduxSet = (data: any) => {
    dialPadChanges(false, true, false, false, false, false);
    dispatch(CallPopUpAgentActions.pushCallDetails(data));
    incomingCallUserData(true, data);
  };

  const conferenceData = (callDetails: any) => {
    dispatch(CallPopUpAgentActions.setCurrentCallDetails(callDetails));
  };

  const incomingCallUserData = (status: any, data: any) => {
    dispatch(
      CallPopUpAgentActions.setIncomingCallDetails({
        status: status,
        incomingCallDetail: data,
      })
    );
  };
  const makeTransferReduxSet = (callDetails: any, data: any) => {
    incomingCallUserData(true, data);
    conferenceData(callDetails);
  };
  const callTimerFunc = (type?: boolean) => {
    clearInterval(CallTimer);
    CallTimer = setInterval(() => {
      dispatch(CallPopUpAgentActions.updateCallTimer());
      if (type) {
        dispatch(ChatActions.updateTimerForCall(store.getState()));
      }
    }, 1000);
    dispatch(ChatActions.clearsessionTimer(CallTimer));
  };
  const basicHold = (userAgent: any) => {
    CallHold(userAgent);
  };
  const callPopUpFunction = (acceptCallRoom: boolean, callSessionDetailswhilePopup: any, isCallAccepted: boolean) => {
    let data = {
      acceptCallRoom: acceptCallRoom,
      callSessionDetailswhilePopup: callSessionDetailswhilePopup,
      isCallAccepted: isCallAccepted,
    };
    console.log("TESTING POPUP DETAILS: ", data, callSessionDetailswhilePopup);
    dispatch(CallPopUpAgentActions.setWholeData(data));
  };

  const dialPadChanges = (isDialPadOpen: any, isCalling: any, isTransfer: any, isTransferSuccess: any, isMergeButton: any, isTransferButton: any) => {
    dispatch(
      CallPopUpAgentActions.DialPadChanges({
        isDialPadOpen: isDialPadOpen,
        isCalling: isCalling,
        isTransfer: isTransfer,
        isTransferSuccess: isTransferSuccess,
        isMergeButton: isMergeButton,
        isTransferButton: isTransferButton,
      })
    );
  };

  const callBackTimerFunc = (num?: string) => {
    const popUpDetails: any = store.getState().callPopUpDetails;
    let { callBackDetails } = popUpDetails;
    let timer: any;
    timer = setInterval(() => {
      const popUp2Details: any = store.getState().callPopUpDetails;
      let { callBackTimer, reject } = popUp2Details;
      if (callBackTimer > 1 && popUp2Details?.isCallBackWaiting) {
        let data1 = {
          isCallBackWaiting: true,
          callBackDetails: callBackDetails,
          callBackTimer: callBackTimer - 1,
          reject: false
        };
        dispatch(CallPopUpAgentActions.setCallBackInfo(data1));
      } else if (reject) {
        let data2 = {
          isCallBackWaiting: false,
          callBackDetails: {},
          callBackTimer: 30,
          reject: false
        };
        dispatch(CallPopUpAgentActions.setCallBackInfo(data2));
        clearInterval(timer)
        // callChatService.callBackReject({ ...callBackDetails, status: 'rejected' });
      } else if (callBackTimer === 1) {
        let data3 = {
          isCallBackWaiting: false,
          callBackDetails: {},
          callBackTimer: 30,
          reject: false
        };
        dispatch(CallPopUpAgentActions.setCallBackInfo(data3));
        callChatService.callBackReject({ ...callBackDetails, status: 'rejected' });
        clearInterval(timer)
      }
    }, 1000);
  };

  const presenceChangeToReady = () => {
    const popUpDetails: any = store.getState().callPopUpDetails;
    const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
    const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
    const LoginUserDetails: any = userDetails;
    let { incomingCallDetail } = popUpDetails;
    const { agentStatus } = store.getState().agentState;
    const { users } = store.getState().userList;
    const presence = sessionStorage.getItem('presence')
    let status: any = null
    if (agentStatus?.length > 0) {
      [status] = agentStatus.filter((i: any) => { return presence === i?.statusName?.trim() })
    }
    let enableStatus: any = null
    if (users?.length > 0) {
      [enableStatus] = users?.filter((i: any) => { return LoginCcaasUserDetails?.emailId === i?.emailId })
    }
    console.log('[SIP - CALL LOG] presenceService call_service', status, enableStatus, presence);
    presenceService?.io?.emit("updatestate_backend", {
      domainId: LoginUserDetails?.domainId,
      isVoice: (enableStatus?.voice === 1 && status?.isVoice === 1 && (popUpDetails?.incomingCallDetail ? Object.keys(popUpDetails?.incomingCallDetail ?? {}).length : 0) === 0) ? 1 : 0,
      isVoiceCallTransfer: status?.isVoiceCallTransfer ?? 0,
      isChat: (enableStatus?.chat === 1 && status?.isChat === 1) ? 1 : 0,
      isChatTransfer: status?.isChatTransfer ?? 0,
      isEmail: (enableStatus?.email === 1 && status?.isEmail === 1) ? 1 : 0,
      isEmailTransfer: status?.isEmailTransfer ?? 0,
      stateTime: Math.floor(Date.now() / 1000),
      statusName: presence,
      ext: LoginUserDetails?.ext,
      email: LoginUserDetails?.Email,
      userId: LoginCcaasUserDetails?.UserID,
      routingProfileId: LoginCcaasUserDetails?.routing_profile_id,
      userName: LoginCcaasUserDetails?.UserName,
      roleId: LoginCcaasUserDetails?.roleid,
      agentStatus: (incomingCallDetail ? Object.keys(incomingCallDetail).length : 0) > 0 ? 0 : 1,
      skill: JSON.parse(enableStatus?.addSkill ?? '[]'),
      routingMethod: enableStatus?.routingMethod ?? 0,
      inboundCall: enableStatus?.inboundCall,
      outboundCampaignCall: enableStatus?.outboundCampaignCall,
      is_outbound_campaign_specific_agent: enableStatus?.is_outbound_campaign_specific_agent
    });
  }
  const updateStatusState = () => {
    try {
      const agentID = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS)?.UserID
      if (agentID) {
        CallServices.get(`/incall?agentId=${agentID}&status=0`)
      }
    } catch (error) {
      console.log(error)
    }
  }

  return {
    createCallConnection,
    makeCallFunction,
    acceptCallFunction,
    declineCallFunction,
    CallMuteFunction,
    CallUnMuteFunction,
    CallHoldFunction,
    sendDTMF,
    CallUnHoldFunction,
    EndCallfunction,
    makeReInvite,
    unregister,
    dialPadChanges,
    transferChanges,
    callPopUpFunction,
    CallTransferFunction,
    makeCallReduxSet,
    makeTransferReduxSet,
    makeCallFunctionForAll,
    incomingCallUserData,
    basicHold,
    superVisorUnMuteFunction,
    superVisorMuteFunction,
    SupervisorEndCall,
    callTimerFunc,
    callBackTimerFunc,
    CallOutboundCampaignFunction
  };
}

/*     const devices = await navigator.mediaDevices.enumerateDevices();
    const outputDevices = devices.filter(device => device.kind === 'audiooutput');
    const inputDevices = devices.filter(device => device.kind === 'audioinput');
    console.log('[SIP - CALL LOG] acceptCallFunction inputDevices', inputDevices)
    console.log('[SIP - CALL LOG] acceptCallFunction outputDevices', outputDevices)
    const defaultInputDevice = inputDevices.find(device => device.deviceId === 'default');
    const defaultOutputDevice = outputDevices.find(device => device.deviceId === 'default');
 
    const isDefaultInputOutput = defaultInputDevice && defaultOutputDevice;
    console.log('[SIP - CALL LOG] isDefaultInputOutput===>', isDefaultInputOutput)
    if (!isDefaultInputOutput) {
      // alert('Microphone access has been denied. Please enable it in your browser settings or exit incognito mode.')
      // return;
      alert("No access to microphone and speaker. Please check your device settings")
    } */